import { useLoader } from '@react-three/fiber';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { TextureLoader } from 'three';

export default function TreeModel2({
  url = '/objs/tree2/tree2.obj',
  mtlUrl = '/objs/tree2/tree2.mtl',
  position = [0, 0, 0],
  scale = 1,
}) {
  const materials = useLoader(MTLLoader, mtlUrl);
  materials.preload();

  const obj = useLoader(OBJLoader, url, loader => {
    loader.setMaterials(materials);
  });

  // Manually load the texture
  const texture = useLoader(TextureLoader, '/objs/tree2/CordylineFREE_BaseColor.png');

  obj.traverse(child => {
    if (child.isMesh) {
      // Assign the texture if not present
      if (!child.material.map) {
        child.material.map = texture;
        child.material.needsUpdate = true;
      }
      child.castShadow = true;
      child.receiveShadow = true;
    }
  });

  return (
    <primitive
      object={obj}
      position={position}
      scale={scale}
      castShadow
      receiveShadow
    />
  );
}